export default __webpack_public_path__ + "alberta-filter-active.5997abce29cab6823901.svg";